import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    // Main studies list
    loading: false,
    studies: [],
    pagination: { page: 1, limit: 20, total: 0, pages: 0 },
    stats: { total: 0, linked: 0, unlinked: 0, ignored: 0 },
    filters: {
        dateFrom: null,
        dateTo: null,
        patientName: '',
        status: 'unlinked', // 'all', 'linked', 'unlinked'
    },
    error: null,

    // Orders for linking
    ordersForLinking: [],
    ordersForLinkingLoading: false,
    ordersForLinkingPagination: { page: 1, limit: 20, total: 0, pages: 0 },

    // Link study to existing order
    linkLoading: false,
    linkRes: null,

    // Quick create order
    quickCreateLoading: false,
    quickCreateRes: null,

    // Ignore/unignore study
    ignoreLoading: false,
    ignoreRes: null,

    // Selected study for dialogs
    selectedStudy: null,
};

const slice = createSlice({
    name: 'allStudies',
    initialState,
    reducers: {
        // Get all studies
        getAllStudiesRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        getAllStudiesSuccess: (state, action) => {
            state.loading = false;
            state.studies = action.payload.data || [];
            state.pagination = action.payload.pagination || initialState.pagination;
            state.stats = action.payload.stats || initialState.stats;
        },
        getAllStudiesFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },

        // Set filters
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetFilters: (state) => {
            state.filters = initialState.filters;
        },

        // Get orders for linking
        getOrdersForLinkingRequest: (state) => {
            state.ordersForLinkingLoading = true;
        },
        getOrdersForLinkingSuccess: (state, action) => {
            state.ordersForLinkingLoading = false;
            state.ordersForLinking = action.payload.data || [];
            state.ordersForLinkingPagination = action.payload.pagination || initialState.ordersForLinkingPagination;
        },
        getOrdersForLinkingFailure: (state, action) => {
            state.ordersForLinkingLoading = false;
            state.ordersForLinking = [];
        },
        resetOrdersForLinking: (state) => {
            state.ordersForLinking = [];
            state.ordersForLinkingPagination = initialState.ordersForLinkingPagination;
        },

        // Link study to order
        linkStudyRequest: (state) => {
            state.linkLoading = true;
            state.linkRes = null;
        },
        linkStudySuccess: (state, action) => {
            state.linkLoading = false;
            state.linkRes = action.payload;
        },
        linkStudyFailure: (state, action) => {
            state.linkLoading = false;
            state.linkRes = action.payload;
        },
        resetLinkStudy: (state) => {
            state.linkRes = null;
        },

        // Quick create order
        quickCreateOrderRequest: (state) => {
            state.quickCreateLoading = true;
            state.quickCreateRes = null;
        },
        quickCreateOrderSuccess: (state, action) => {
            state.quickCreateLoading = false;
            state.quickCreateRes = action.payload;
        },
        quickCreateOrderFailure: (state, action) => {
            state.quickCreateLoading = false;
            state.quickCreateRes = action.payload;
        },
        resetQuickCreateOrder: (state) => {
            state.quickCreateRes = null;
        },

        // Ignore study
        ignoreStudyRequest: (state) => {
            state.ignoreLoading = true;
            state.ignoreRes = null;
        },
        ignoreStudySuccess: (state, action) => {
            state.ignoreLoading = false;
            state.ignoreRes = action.payload;
        },
        ignoreStudyFailure: (state, action) => {
            state.ignoreLoading = false;
            state.ignoreRes = action.payload;
        },
        resetIgnoreStudy: (state) => {
            state.ignoreRes = null;
        },

        // Selected study
        setSelectedStudy: (state, action) => {
            state.selectedStudy = action.payload;
        },
        clearSelectedStudy: (state) => {
            state.selectedStudy = null;
        },
    },
});

export const {
    getAllStudiesRequest,
    getAllStudiesSuccess,
    getAllStudiesFailure,
    setFilters,
    resetFilters,
    getOrdersForLinkingRequest,
    getOrdersForLinkingSuccess,
    getOrdersForLinkingFailure,
    resetOrdersForLinking,
    linkStudyRequest,
    linkStudySuccess,
    linkStudyFailure,
    resetLinkStudy,
    quickCreateOrderRequest,
    quickCreateOrderSuccess,
    quickCreateOrderFailure,
    resetQuickCreateOrder,
    ignoreStudyRequest,
    ignoreStudySuccess,
    ignoreStudyFailure,
    resetIgnoreStudy,
    setSelectedStudy,
    clearSelectedStudy,
} = slice.actions;

export default slice.reducer;
